var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("administration.user_add") } },
    [
      _c(
        "template",
        { slot: "primaryActions" },
        [
          _c("app-button", {
            attrs: {
              text: _vm.$t("common.bck"),
              icon: "fa-light fa-arrow-left",
              variant: "primary",
            },
            on: { click: _vm.goBack },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "form-accordion",
                {
                  attrs: {
                    title: _vm.$t("administration.user_info"),
                    isTitleUpperCase: false,
                  },
                },
                [
                  _c("div", { staticClass: "form-group" }),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: {
                              isMandatory: "",
                              inputLabel: _vm.$t("administration.identifier"),
                              placeholderValue: _vm.$t(
                                "administration.identifier"
                              ),
                            },
                            model: {
                              value: _vm.login,
                              callback: function ($$v) {
                                _vm.login = $$v
                              },
                              expression: "login",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: {
                              isMandatory: "",
                              inputLabel: _vm.$t("administration.user_name"),
                              placeholderValue: _vm.$t(
                                "administration.user_name"
                              ),
                            },
                            model: {
                              value: _vm.name,
                              callback: function ($$v) {
                                _vm.name = $$v
                              },
                              expression: "name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: {
                              isMandatory: "",
                              inputLabel: _vm.$t("administration.email"),
                              placeholderValue: _vm.$t("administration.email"),
                            },
                            model: {
                              value: _vm.email,
                              callback: function ($$v) {
                                _vm.email = $$v
                              },
                              expression: "email",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("label", { attrs: { for: "password-field" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("administration.password")) + " "
                            ),
                            _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v("*"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "d-flex" }, [
                            _vm.passwordType === "checkbox"
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.password,
                                      expression: "password",
                                    },
                                  ],
                                  staticClass:
                                    "form-control inputAccordionForm h-30px",
                                  attrs: {
                                    id: "password-field",
                                    placeholder: _vm.$t(
                                      "administration.password"
                                    ),
                                    required: "",
                                    "aria-describedby":
                                      "password-visibility-toggle",
                                    type: "checkbox",
                                  },
                                  domProps: {
                                    checked: Array.isArray(_vm.password)
                                      ? _vm._i(_vm.password, null) > -1
                                      : _vm.password,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.password,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.password = $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.password = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.password = $$c
                                      }
                                    },
                                  },
                                })
                              : _vm.passwordType === "radio"
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.password,
                                      expression: "password",
                                    },
                                  ],
                                  staticClass:
                                    "form-control inputAccordionForm h-30px",
                                  attrs: {
                                    id: "password-field",
                                    placeholder: _vm.$t(
                                      "administration.password"
                                    ),
                                    required: "",
                                    "aria-describedby":
                                      "password-visibility-toggle",
                                    type: "radio",
                                  },
                                  domProps: {
                                    checked: _vm._q(_vm.password, null),
                                  },
                                  on: {
                                    change: function ($event) {
                                      _vm.password = null
                                    },
                                  },
                                })
                              : _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.password,
                                      expression: "password",
                                    },
                                  ],
                                  staticClass:
                                    "form-control inputAccordionForm h-30px",
                                  attrs: {
                                    id: "password-field",
                                    placeholder: _vm.$t(
                                      "administration.password"
                                    ),
                                    required: "",
                                    "aria-describedby":
                                      "password-visibility-toggle",
                                    type: _vm.passwordType,
                                  },
                                  domProps: { value: _vm.password },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.password = $event.target.value
                                    },
                                  },
                                }),
                            _vm._v(" "),
                            _c("button", {
                              staticClass:
                                "icon icon-password mt-2 pt-1 icon-field",
                              class: [
                                _vm.isPasswordFieldHidden
                                  ? "fa-duotone fa-eye"
                                  : "fa-duotone fa-eye-slash",
                              ],
                              attrs: {
                                type: "button",
                                id: "password-visibility-toggle",
                                "aria-label": _vm.isPasswordFieldHidden
                                  ? _vm.$t("common.show_password")
                                  : _vm.$t("common.hide_password"),
                                "aria-pressed": !_vm.isPasswordFieldHidden,
                              },
                              on: { click: _vm.switchPasswordType },
                            }),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "form-accordion",
                {
                  attrs: {
                    title: _vm.$t("administration.user_auth"),
                    isTitleUpperCase: false,
                  },
                },
                [
                  _c(
                    "b-row",
                    { staticClass: "justify-content-start" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            "b-col",
                            { staticClass: "px-0", attrs: { cols: "12" } },
                            [
                              _c(
                                "label",
                                { attrs: { for: "select-company-name" } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t("administration.company_name")
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.idAccount,
                                      expression: "idAccount",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    id: "select-company-name",
                                    required: "",
                                    "aria-describedby": _vm.idAccount
                                      ? ""
                                      : "company-help",
                                    "aria-label": _vm.$t(
                                      "administration.company_name"
                                    ),
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.idAccount = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "option",
                                    { attrs: { value: "", disabled: "" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "administration.select_company"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.allCompanies,
                                    function (company, index) {
                                      return _c(
                                        "option",
                                        {
                                          key:
                                            "filtered-profile-" +
                                            company.idAccount +
                                            "-" +
                                            index,
                                          domProps: {
                                            value: company.idAccount,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(company.name) +
                                              "\n                "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              !_vm.idAccount
                                ? _c(
                                    "small",
                                    {
                                      staticClass: "form-text text-muted",
                                      attrs: { id: "company-help" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "administration.select_company_help"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.idAccount === "new"
                        ? _c(
                            "b-col",
                            { attrs: { cols: "3" } },
                            [
                              _c(
                                "b-col",
                                { staticClass: "px-0", attrs: { cols: "12" } },
                                [
                                  _c("label", [
                                    _vm._v(
                                      "\n                Compte de rattachement\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.idAccountParent,
                                          expression: "idAccountParent",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.idAccountParent = $event.target
                                            .multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "option",
                                        { attrs: { value: "", disabled: "" } },
                                        [
                                          _vm._v(
                                            "Selectionner le compte de rattachement"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.allCompanies,
                                        function (company, index) {
                                          return _c(
                                            "option",
                                            {
                                              key:
                                                "filtered-profile-" +
                                                company.idAccount +
                                                "-" +
                                                index,
                                              domProps: {
                                                value: company.idAccount,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(company.name) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.idAccount === "new"
                        ? _c(
                            "b-col",
                            { attrs: { cols: "3" } },
                            [
                              _c("form-write-group-label-input", {
                                attrs: {
                                  isMandatory: "",
                                  inputLabel: "Nom du compte",
                                  placeholderValue: "Nom du compte",
                                },
                                model: {
                                  value: _vm.accountName,
                                  callback: function ($$v) {
                                    _vm.accountName = $$v
                                  },
                                  expression: "accountName",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            "b-col",
                            { staticClass: "px-0", attrs: { cols: "12" } },
                            [
                              _c(
                                "label",
                                { attrs: { for: "rights-profile" } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("administration.profile")) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.id_rights_profile,
                                      expression: "id_rights_profile",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    id: "select-rights-profile",
                                    "aria-label": _vm.$t(
                                      "administration.profile"
                                    ),
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.id_rights_profile = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "option",
                                    { attrs: { value: "", disabled: "" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "administration.select_profile"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.AllProfiles,
                                    function (profile, index) {
                                      return _c(
                                        "option",
                                        {
                                          key:
                                            "filtered-profile-" +
                                            profile.id +
                                            "-" +
                                            index,
                                          attrs: { disabled: profile.disabled },
                                          domProps: {
                                            value:
                                              _vm.idAccount === "new"
                                                ? profile.name
                                                : profile.id,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(profile.name) +
                                              "\n                "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "bottomActions" },
        [
          _c("app-button", {
            attrs: {
              text: _vm.$t("common.sve"),
              icon: "fa-light fa-save",
              variant: "primary",
            },
            on: { click: _vm.createUser },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }